import { API_REQUEST_TYPES } from "../../enums";
import { resetApi } from "../../services/axios";
import { checkAndGetInvitationStatus } from "../../screens/my-projects/utils";
import {
  setInvitationDetailsData,
  setInvitationDetailsError,
  setInvitationDetailsLoading,
  setInvitationListData,
  setInvitationListError,
  setInvitationListLoading,
} from "../../store/modules/invitation";

import { API } from "../endpoints";
import { getUpdatedProjectInvitationList } from "../projects/utils";

export function getInvitations(payload) {
  return async function (dispatch) {
    const res = await dispatch(
      resetApi({
        type: API_REQUEST_TYPES.GET,
        url: API.INVITATIONS.GET_INVITATIONS(payload),
        payload: {},
        config: {
          notifyError: true,
          loadingFn: setInvitationListLoading,
          failFn: setInvitationListError,
        },
      })
    );

    if (res.success) {

    }

    return {
      ...res,
      data: getUpdatedProjectInvitationList(res?.data?.data)
    };
  };
}

export function getInvitationById(id) {
  return async function (dispatch) {
    let res = await dispatch(
      resetApi({
        type: API_REQUEST_TYPES.GET,
        url: API.INVITATIONS.GET_INVITATION_BY_ID(id),
        payload: {},
        config: {
          notifyError: true,
          loadingFn: setInvitationDetailsLoading,
        },
      })
    );

    if (res.success) {
      res = {
        ...res,
        data: {
          ...res.data,
          status: checkAndGetInvitationStatus(res?.data),
        },
      };

      dispatch(setInvitationDetailsData(res.data));
    } else {
      dispatch(setInvitationDetailsError(res.message));
    }

    return res;
  };
}

export function getInvitationByIdNoAuth(id, token) {
  return async function (dispatch) {
    let res = await dispatch(
      resetApi({
        type: API_REQUEST_TYPES.GET,
        url: API.INVITATIONS.GET_INVITATION_BY_ID_NO_AUTH(id, token),
        payload: {},
        config: {
          notifyError: true,
          loadingFn: setInvitationDetailsLoading,
        },
      })
    );

    if (res.success) {
      res = {
        ...res,
        data: {
          ...res.data,
          status: checkAndGetInvitationStatus(res?.data),
        },
      };

      dispatch(setInvitationDetailsData(res.data));
    } else {
      dispatch(setInvitationDetailsError(res.message));
    }

    return res;
  };
}

export function submitAmbassadorResponse(payload, id) {
  return async function (dispatch) {
    const res = await dispatch(
      resetApi({
        type: API_REQUEST_TYPES.PUT,
        url: API.INVITATIONS.SUBMIT_AMBASSADOR_RESPONSE(id),
        payload,
        config: {
          notifyError: true,
        },
      })
    );

    if (res.success) {
    }

    return res;
  };
}

export function submitAmbassadorSelectedSlot(payload, id) {
  return async function (dispatch) {
    const res = await dispatch(
      resetApi({
        type: API_REQUEST_TYPES.PUT,
        url: API.INVITATIONS.SUBMIT_AMBASSADOR_SELECTED_SLOT(id),
        payload,
        config: {
          notifyError: true,
        },
      })
    );

    if (res.success) {
    }

    return res;
  };
}

export function submitVendorSelectedSlot(payload, id) {
  return async function (dispatch) {
    const res = await dispatch(
      resetApi({
        type: API_REQUEST_TYPES.PUT,
        url: API.INVITATIONS.SUBMIT_VENDOR_SELECTED_SLOT(id),
        payload,
        config: {
          notifyError: true,
        },
      })
    );

    if (res.success) {
    }

    return res;
  };
}

export function submitAmbassadorSuggestedSlot(payload, id) {
  return async function (dispatch) {
    const res = await dispatch(
      resetApi({
        type: API_REQUEST_TYPES.PUT,
        url: API.INVITATIONS.SUBMIT_AMBASSADOR_SUGGESTED_SLOT(id),
        payload,
        config: {
          notifyError: true,
        },
      })
    );

    if (res.success) {
    }

    return res;
  };
}

export function submitVendorApproval(id) {
  return async function (dispatch) {
    const res = await dispatch(
      resetApi({
        type: API_REQUEST_TYPES.PUT,
        url: API.INVITATIONS.SUBMIT_VENDOR_APPROVE(id),
        payload: {},
        config: {
          notifyError: true,
        },
      })
    );

    if (res.success) {
    }

    return res;
  };
}

export function sendVendorCalendlySlots(id) {
  return async function (dispatch) {
    const res = await dispatch(
      resetApi({
        type: API_REQUEST_TYPES.PUT,
        url: API.INVITATIONS.SEND_VENDOR_CALENDLY_SLOT(id),
        payload: {},
        config: {
          notifyError: true,
        },
      })
    );

    if (res.success) {
    }

    return res;
  };
}

export function submitMarkAsCompleted(id) {
  return async function (dispatch) {
    const res = await dispatch(
      resetApi({
        type: API_REQUEST_TYPES.PUT,
        url: API.INVITATIONS.SUBMIT_MARK_AS_COMPLETED(id),
        payload: {},
        config: {
          notifyError: true,
        },
      })
    );

    if (res.success) {
    }

    return res;
  };
}

export function submitMarkAsCancelled({ id, message }) {
  return async function (dispatch) {
    const res = await dispatch(
      resetApi({
        type: API_REQUEST_TYPES.PUT,
        url: API.INVITATIONS.SUBMIT_MARK_AS_CANCELLED(id),
        payload: { message },
        config: {
          notifyError: true,
        },
      })
    );

    if (res.success) {
    }

    return res;
  };
}

export function submitInvitationRejected({ id, message }) {
  return async function (dispatch) {
    const res = await dispatch(
      resetApi({
        type: API_REQUEST_TYPES.PUT,
        url: API.INVITATIONS.SUBMIT_INVITATION_REJECTED(id),
        payload: { message },
        config: {
          notifyError: true,
        },
      })
    );

    if (res.success) {
    }

    return res;
  };
}

export function rejectInvitationByToken(token, message) {
  return async function (dispatch) {
    const res = await dispatch(
      resetApi({
        type: API_REQUEST_TYPES.POST,
        url: API.INVITATIONS.REJECT_BY_TOKEN(token),
        payload: { message },
        config: {
          validateUser: false,
          notifyError: true,
          notifySuccess: true,
        },
      })
    );

    return res;
  };
}

export function updateInvitation(payload) {
  return async function (dispatch) {
    const { id, additionalMembers } = payload;

    const res = await dispatch(
      resetApi({
        type: API_REQUEST_TYPES.PUT,
        url: API.INVITATIONS.UPDATE_INVITATION({ id }),
        payload: {
          ...(additionalMembers && { additionalMembers }),
        },
        config: {
          notifyError: true,
        },
      })
    );

    if (res.success) {
    }

    return res;
  };
}

export function getVendorCalendlySlots(payload) {
  return async function (dispatch) {
    const res = await dispatch(
      resetApi({
        type: API_REQUEST_TYPES.GET,
        url: API.CALENDLY.GET_AVAILIBILITY(payload),
        config: {
          notifyError: false,
        },
      })
    );

    if (res.success) {
    }

    return res;
  };
}

export function transferRoleSubmit(payload) {
  return async function (dispatch) {
    const res = await dispatch(
      resetApi({
        type: API_REQUEST_TYPES.POST,
        url: API.INVITATIONS.POST_TRANSFER_ROLE,
        payload,
        config: {
          notifyError: true,
        },
      })
    );

    if (res.success) {
    }

    return res;
  };
}

export function deleteTransferRole(payload) {
  return async function (dispatch) {
    const res = await dispatch(
      resetApi({
        type: API_REQUEST_TYPES.DELETE,
        url: API.INVITATIONS.POST_TRANSFER_ROLE,
        payload,
        config: {
          notifyError: true,
        },
      })
    );

    return res;
  };
}

export function getMeetingSummaryData(token) {
  return async function (dispatch) {
    const res = await dispatch(
      resetApi({
        type: API_REQUEST_TYPES.GET,
        url: API.INVITATIONS.GET_MEETING_SUMMARY(token),
        config: {
          notifyError: false,
        },
      })
    );

    if (res.success) {
    }

    return res;
  };
}

export function getAmbassadorInvitationRecordings(
  filters = { from: "", to: "", clientId: "", ambassadorId: "" }
) {
  return async function (dispatch) {
    const res = await dispatch(
      resetApi({
        type: API_REQUEST_TYPES.GET,
        url: API.INVITATIONS.GET_AMBASSADOR_INVITATION_RECORDINGS(filters),
        config: {
          notifyError: false,
        },
      })
    );

    if (res.success) {
    }

    return res;
  };
}

export function getAmbassadorInvitationParticipants() {
  return async function (dispatch) {
    const res = await dispatch(
      resetApi({
        type: API_REQUEST_TYPES.GET,
        url: API.INVITATIONS.GET_AMBASSADOR_INVITATION_PARTICIPANTS,
        config: {
          notifyError: false,
        },
      })
    );

    if (res.success) {
    }

    return res;
  };
}

export function requestMeetingCoordination({ id, initiatedBy }) {
  return async function (dispatch) {
    const res = await dispatch(
      resetApi({
        type: API_REQUEST_TYPES.PUT,
        url: API.INVITATIONS.REQUEST_COORDINATION(id),
        payload: {
          ...(initiatedBy && { initiatedBy }),
        },
        config: {
          notifyError: true,
          notifySuccess: true,
        },
      })
    );

    return res;
  };
}

export function submitMeetingReschedule(payload, id) {
  return async function (dispatch) {
    const res = await dispatch(
      resetApi({
        type: API_REQUEST_TYPES.PUT,
        url: API.INVITATIONS.SUBMIT_RESCHEDULE(id),
        payload,
        config: {
          notifyError: true,
          notifySuccess: true,
        },
      })
    );

    return res;
  };
}

export function confirmMeetingAttendance(id) {
  return async function (dispatch) {
    const res = await dispatch(
      resetApi({
        type: API_REQUEST_TYPES.PUT,
        url: API.INVITATIONS.CONFIRM_ATTENDANCE(id),
        payload: {},
        config: {
          notifyError: true,
          notifySuccess: true,
        },
      })
    );

    return res;
  };
}

export function submitRescheduleRequest(id) {
  return async function (dispatch) {
    const res = await dispatch(
      resetApi({
        type: API_REQUEST_TYPES.PUT,
        url: API.INVITATIONS.RESCHEDULE_REQUEST(id),
        config: {
          notifyError: true,
          notifySuccess: true,
        },
      })
    );
    return res;
  };
}
